<ca-filter-panel
  [config]="filterPanelConfig"
  (collapsed)="onFilterPanelCollapsed($event)"
  (expanded)="onFilterPanelExpanded($event)"
  (valueChanges)="onFilterValueChanges($event)"
  #filterPanel
></ca-filter-panel>
